<template>
  <v-container>
    <v-row justify="center">
      <v-card elevation="0" max-width="1024">
        <PicturePage/>
        <QuizPanel/>
      </v-card>
      <BuzzIn/>
    </v-row>
  </v-container>
</template>

<script>
import QuizPanel from "@/components/QuizPanel";
import BuzzIn from "@/components/BuzzIn";
import PicturePage from "@/components/PicturePage";

export default {
  name: 'QuizMasterPage',
  components: {
    PicturePage,
    BuzzIn,
    QuizPanel,
  },
}
</script>
